import React from 'react'

export default function TriggerIcon() {
  return (
    <svg width="30px" height="35px" viewBox="0 0 36 42" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Trigger" stroke="none" strokeWidth="1" fillRule="evenodd">
        <rect x="10.3" y="0" width="3.4" height="7" rx="1.7" />
        <rect x="0" y="9.3" width="7" height="3.4" rx="1.7" />
        <rect x="4.6" y="2.05" width="3.4" height="6.5" rx="1.7" transform="rotate(-45 6.3 5.3)" />
        <rect x="16" y="2.05" width="3.4" height="6.5" rx="1.7" transform="rotate(45 17.7 5.3)" />
        <rect x="4.6" y="13.45" width="3.4" height="6.5" rx="1.7" transform="rotate(45 6.3 16.7)" />
        <path d="M12,11 L12,36.5 L18.75,30.5 L23.25,41 L27.75,39.2 L23.4,29 L31.5,29 Z" />
      </g>
    </svg>
  )
}
